import fetchPlus from '../lib/fetchPlus/fetchPlus';
import type { ApiResponse } from '../types/API/ApiResponse';

export interface Report {
    /** tlkpPortalReport.ID - the report's id in the legacy catalogue. */
    id: number;
    Name: string;
    Description: string;
    Path: string;
    ExportExcel: '1' | '0';
}

// Report access is allocated per user in auth, so the list comes from auth-api and
// already contains only the reports this user is allowed to see. The pest API's
// /reports endpoint this replaced could not gate by user: it was keyed on the legacy
// CustomerUserID, which auth users no longer carry.
const reportsService = {
    getReports: () =>
        fetchPlus<ApiResponse<'data', { reports: Report[] }>>(
            `${process.env.NEXT_PUBLIC_AUTH_API}/auth/me/hub-reports`,
            'GET',
        ),
};

export default reportsService;
